<app-page-header title="Home" active_item="Depósito" titleLink="/reports"  ></app-page-header>
<div class="loading-deposit" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>{{ 'common.pixKeyDeposit' | translate }}</h5>
<div class="row">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title pt-0">{{ 'common.bankDetails' | translate }}</div>
      </div>
      <div class="card-body-info">
          <div class="row">
            <div class="row mt-3">
              <div class="col-4">
                <div class="form-group">
                  <label for="txtChavePix" class="form-label">{{ 'common.pixKey' | translate }}</label>
                  <div class="input-icon-container"> 
                    <input [(ngModel)]="chavePixDeposito" 
                    class="form-control" 
                    type="text" 
                    id="txtChavePix" 
                    [readonly]="true">
                    <i (click)="copyPixKey()" class="fe fe-copy input-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label for="txtNomeTitular" class="form-label">{{ 'common.holderName' | translate }}</label>
                  <input [(ngModel)]="nomeTitular" 
                         class="form-control" 
                         type="text" 
                         id="txtNomeTitular" 
                         [readonly]="true">
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label for="txtBanco" class="form-label">{{ 'common.bank' | translate }}</label>
                  <input [(ngModel)]="banco" 
                         class="form-control" 
                         type="text" 
                         id="txtBanco" 
                         [readonly]="true">
                </div>
              </div>
          </div>
          </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">{{ 'common.transactionData' | translate }}</div>
      </div>
      <div class="card-body">
        <form [formGroup]="depositoPix">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="endToEndId" class="form-label">{{ 'common.bankTransactionId' | translate }} <span class="text-danger">*</span>
                <i class="fe fe-help-circle text-primary ms-2" data-bs-toggle="tooltip" data-bs-placement="top" title="O ID de Transação é um código único gerado pelo banco para identificar a transação. O mesmo se encontra no comprovante bancário, e sempre começará com a inicial E. "></i>
                </label>
                <div class="input-icon-container">
                  <input [formControl]="depositoPix.controls.idTransacao" class="form-control" [ngClass]="{'is-invalid state-invalid': depositoPix.controls.idTransacao.invalid && isSubmitted}" type="text" name="endToEndId" id="txtEndToEndId" [required]="true">
                  <div class="invalid-feedback">{{idFeedback}}</div>
                  <i (click)="paste()" class="fe fe-copy input-icon"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl col-lg-6 col-sm-6 mas-auto">
              <button type="button" class="our-button btn btn-pill btn-primary" (click)="openDataConfirm()"><i class="fe fe-arrow-down-right"></i>{{ 'common.depositButton' | translate }}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="openConfirm">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">Confirmar os dados</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-xl-6 col-lg-12 col-sm-12">
            <div class="form-group">
              <label for="txtNome" class="form-label"
                >Recebedor</label
              >
              <input
                [(ngModel)]="nomeRecebedor"
                class="form-control"
                type="text"
                name="nomeRecebedor"
                id="txtNomeRecebedor"
                [readonly]="true"
              />
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-sm-6">
            <div class="form-group">
              <label for="txtDocumentoRecebedor" class="form-label"
                >Documento
              </label>
              <input
                [(ngModel)]="documentoRecebedor"
                class="form-control"
                type="text"
                name="documentoRecebedor"
                id="txtDocumentoRecebedor"
                [readonly]="true"
              />
            </div>
          </div>
          <div class="col-xl-6 col-lg-12 col-sm-12">
            <div class="form-group">
              <label for="txtData" class="form-label"
                >Data</label
              >
              <input
                [(ngModel)]="data"
                class="form-control"
                type="text"
                name="data"
                id="txtData"
                [readonly]="true"
              />
            </div>
          </div>
          <div class="col-xl-4 col-lg-12 col-sm-12">
            <div class="form-group">
              <label for="txtValor" class="form-label"
                >Valor</label
              >
              <input [prefix]="( '' | currencySymbol )" [(ngModel)]="valor" mask="separator.2" [leadZero]="true" decimalMarker="," thousandSeparator="." class="form-control" type="text" name="valor" id="txtValor" [readonly]="true">
            </div>
          </div>
          <div class="col-xl-1 col-lg-6 col-sm-6">
            <button
              type="button"
              class="our-button btn btn-pill btn-primary"
              (click)="makeDeposit()"
            >
              <i class="fe fe-arrow-up-right"></i>Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click'); isLoaded = true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>
    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp()"
      />
      <button
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{'login.totp.pasteButton' | translate}}
      </button>
    </div>
  </div>
  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
    >
      VALIDAR
    </button>
  </div>
</ng-template>
